import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";
import { WIDGET_ADD_SIGNAL_OVERVIEW_PREVIEW_QUERY } from "./WidgetAddSignalOverviewPreview";
import { useDebouncedCallback } from "use-debounce";
import { useFocusEffect } from "@react-navigation/native";
import { WidgetAddSignalOverviewPreviewQuery } from "./__generated__/WidgetAddSignalOverviewPreviewQuery.graphql";

export function useWidgetAddSignalOverviewPreviewQuery({
  storecastId,
  teamIds,
}: {
  storecastId: string;
  teamIds: string[];
}) {
  const [query, loadQuery] =
    useQueryLoader<WidgetAddSignalOverviewPreviewQuery>(
      WIDGET_ADD_SIGNAL_OVERVIEW_PREVIEW_QUERY
    );

  const environment = useRelayEnvironment();

  const loadPreviewQuery = useDebouncedCallback(
    async (newTeamIds: string[]) => {
      try {
        const variables = {
          storecastId,
          input: {
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
            size: "TWO_X_TWO" as const,
          },
        };
        await fetchQuery(
          environment,
          WIDGET_ADD_SIGNAL_OVERVIEW_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadQuery(variables, {
          fetchPolicy: "store-and-network",
        });
      } catch {}
    },
    300
  );
  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds);
    }, [teamIds, loadPreviewQuery])
  );

  return query;
}
